import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "flex flex-col py-1 px-10"
};
const _hoisted_2 = {
  class: "text-lg text-left"
};
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-left"
};
const _hoisted_4 = {
  class: "block p-2"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col align-middle justify-start px-10"
};
const _hoisted_7 = {
  class: "px-2 mx-2"
};
const _hoisted_8 = {
  class: "px-2 mx-2"
};
const _hoisted_9 = {
  class: "px-2 mx-2"
};
const _hoisted_10 = {
  class: "flex flex-col items-center pr-2"
};
const _hoisted_11 = {
  class: "pricing-card bg-white rounded-lg shadow-sm border border-gray-100 p-6 w-72 text-center"
};
const _hoisted_12 = {
  class: "text-sm text-gray-800 font-medium mb-4"
};
const _hoisted_13 = {
  class: "text-2xl font-bold text-black mb-1"
};
const _hoisted_14 = {
  class: "text-sm text-gray-500 mb-4"
};
const _hoisted_15 = {
  class: "text-xs text-gray-400 mb-6"
};
const _hoisted_16 = {
  class: "flex items-center justify-center text-primary font-medium py-2"
};
const _hoisted_17 = {
  class: "centered-block"
};
const _hoisted_18 = {
  class: "flex items-center justify-between"
};
const _hoisted_19 = {
  class: "flex items-center gap-4"
};
const _hoisted_20 = {
  key: 0,
  class: "text-sm text-gray-600"
};
const _hoisted_21 = {
  key: 1,
  class: "text-sm text-gray-600"
};
const _hoisted_22 = {
  key: 0,
  class: "flex gap-2"
};
import { onMounted, reactive, computed, toRef, watch, ref } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlIcon from '@/components/LlIcon.vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useMaxioSubscriptionStore } from './useMaxioSubscriptionStore';
import { pluralizeWithCount, isValidSingleEmail } from '@/services/utils';
import RouteService from '@/services/RouteService';
import CancelSubscriptionModal from './CancelSubscriptionModal.vue';
import LlTextField from '@/components/LlTextField.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import { usePricingCalculations } from './usePricingCalculations.js';
export default {
  __name: 'MaxioSelectedPlan',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    interval: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSmallScreen: {
      type: Boolean,
      default: false
    },
    userService: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    }
  },
  emits: ['pickDifferentPlan', 'startSubscription'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      openChat
    } = useSupportChat();

    // Get features from the MeStore
    const meStore = useMeStore();
    const {
      features
    } = storeToRefs(meStore);
    const props = __props;
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    maxioCompanySubscriptionStore.alerts = props.alerts;
    const selectedPlanState = reactive({
      loading: false,
      selectedPlan: '',
      description: null,
      card: null,
      isSubscribed: false,
      plan: null,
      subscription: props.subscription,
      routeService: {},
      minSeats: props.subscription?.plan?.seats || props.subscription?.seatsRequired,
      showCancelSubscriptionModal: false,
      isUpdating: false,
      // For consolidated save
      originalSeats: null,
      originalCouponCode: '',
      originalBillingEmail: null,
      // Form validation states
      seatsValid: true,
      emailValid: true,
      disableStartSubscription: computed(() => {
        const isLoading = selectedPlanState.loading;
        const hasBankInfo = selectedPlanState.subscription?.bank;
        const isAchVerified = maxioCompanySubscriptionStore.isAchVerified;
        const hasCardInfo = selectedPlanState.subscription?.card;
        const isActiveSubscription = maxioCompanySubscriptionStore.isActiveSubscription;
        return isLoading || isActiveSubscription && !hasChanges.value || !(hasCardInfo || hasBankInfo && isAchVerified);
      })
    });
    const emit = __emit;

    // Coupon validation state (following PlanSelection pattern)
    const validatedCoupon = ref(null);
    const lastValidatedCode = ref('');
    onMounted(async () => {
      selectedPlanState.routeService = new RouteService(props);
      selectedPlanState.seats = props.subscription?.plan?.seats || props.subscription?.seatsRequired;
      selectedPlanState.couponCode = props.subscription?.couponCode || '';
      selectedPlanState.billingEmail = props.subscription?.email;
      selectedPlanState.card = props.subscription.card;

      // Store original values for change tracking
      selectedPlanState.originalSeats = selectedPlanState.seats;
      selectedPlanState.originalCouponCode = selectedPlanState.couponCode;
      selectedPlanState.originalBillingEmail = selectedPlanState.billingEmail;

      // Initialize validation states
      selectedPlanState.seatsValid = Number(selectedPlanState.seats) >= selectedPlanState.minSeats;
      selectedPlanState.emailValid = !selectedPlanState.billingEmail || isValidSingleEmail(selectedPlanState.billingEmail);
    });

    // Reset coupon validation if user edits coupon code (following PlanSelection pattern)
    watch(() => selectedPlanState.couponCode, () => {
      if (selectedPlanState.couponCode !== lastValidatedCode.value) {
        validatedCoupon.value = null;
      }
    });

    // Computed property for the consolidated save button
    const hasChanges = computed(() => {
      return Number(selectedPlanState.seats) !== Number(selectedPlanState.originalSeats) || selectedPlanState.couponCode !== selectedPlanState.originalCouponCode || selectedPlanState.billingEmail !== selectedPlanState.originalBillingEmail;
    });

    // Computed property to check if form is valid (following PlanSelection pattern)
    const isFormValid = computed(() => {
      const basicValid = selectedPlanState.seatsValid && selectedPlanState.emailValid;

      // If no coupon code, basic validation is enough
      if (!selectedPlanState.couponCode) {
        return basicValid;
      }

      // If coupon code is present, it must be validated (following PlanSelection logic)
      return basicValid && validatedCoupon.value !== null && selectedPlanState.couponCode === lastValidatedCode.value;
    });
    const {
      priceBreakdown,
      totalAmount,
      formattedDisplayAmount,
      billingPeriodText
    } = usePricingCalculations({
      plan: computed(() => props.subscription?.plan),
      interval: toRef(props, 'interval'),
      seats: computed(() => selectedPlanState.seats),
      subscription: toRef(props, 'subscription')
    });
    const startSubscription = async () => {
      selectedPlanState.loading = true;
      const params = {
        seats: selectedPlanState.seats,
        couponCode: selectedPlanState?.couponCode,
        email: selectedPlanState?.billingEmail
      };
      selectedPlanState.loading = true;
      const response = await maxioCompanySubscriptionStore.createSubscription(params);
      if (response) {
        props.alerts?.success('Welcome! You are now subscribed to LeanLaw.');
        selectedPlanState.loading = false;
        selectedPlanState.isSubscribed = true;
        selectedPlanState.routeService.go('settings.company.maxioCompanySubscription');
        emit('startSubscription');
      } else {
        props.alerts?.error('Error starting subscription');
        selectedPlanState.loading = false;
      }
    };
    const pickDifferentPlan = async () => {
      emit('pickDifferentPlan');
    };
    const validEmail = computed(() => {
      const billingEmail = selectedPlanState.billingEmail;
      if (!billingEmail) return true; // optional field
      return isValidSingleEmail(billingEmail);
    });

    // Coupon validation function (following PlanSelection pattern with test compatibility)
    const validateCode = async () => {
      if (!selectedPlanState.couponCode) {
        props.alerts?.error('Please enter a coupon code');
        return;
      }
      try {
        const productId = props.subscription?.product?.id;
        if (!productId) {
          throw new Error('Unable to validate coupon - no plan selected');
        }
        const result = await maxioCompanySubscriptionStore.verifyCoupon(productId, selectedPlanState.couponCode);

        // Persist the response (following PlanSelection pattern)
        validatedCoupon.value = result || null;
        lastValidatedCode.value = selectedPlanState.couponCode;
        props.alerts?.success('Coupon code is valid and will be applied when you save');
      } catch (e) {
        // On failure, clear the coupon and reset validation state (following PlanSelection pattern)
        selectedPlanState.couponCode = selectedPlanState.originalCouponCode || '';
        lastValidatedCode.value = '';
        validatedCoupon.value = null;
      }
    };

    // Consolidated update function for all subscription changes
    const updateSubscription = async () => {
      selectedPlanState.isUpdating = true;
      try {
        const updates = {};
        const messages = [];

        // Validate email if changed
        if (selectedPlanState.billingEmail !== selectedPlanState.originalBillingEmail) {
          if (!validEmail.value) {
            props.alerts?.error('Please enter a valid email address');
            selectedPlanState.isUpdating = false;
            return;
          }
          updates.email = selectedPlanState.billingEmail;
          messages.push('billing email');
        }

        // Validate seats if changed
        if (selectedPlanState.seats !== selectedPlanState.originalSeats) {
          const newSeats = Number(selectedPlanState.seats);
          const minSeats = Number(selectedPlanState.minSeats);
          if (newSeats < minSeats) {
            props.alerts?.error(`Seats cannot be less than ${minSeats}`);
            selectedPlanState.isUpdating = false;
            return;
          }
          updates.seats = newSeats;
          messages.push(`seats (${pluralizeWithCount(newSeats, 'seat')})`);
        }

        // Include coupon if changed (even if just validating)
        if (selectedPlanState.couponCode !== selectedPlanState.originalCouponCode) {
          updates.couponCode = selectedPlanState.couponCode;
          if (selectedPlanState.couponCode) {
            messages.push('coupon code');
          }
        }
        if (Object.keys(updates).length === 0) {
          props.alerts?.info('No changes to save');
          selectedPlanState.isUpdating = false;
          return;
        }

        // Make the consolidated update
        const successMessage = `Successfully updated ${messages.join(', ')}`;
        await maxioCompanySubscriptionStore.updateSubscriptions(updates, successMessage);

        // Update original values to reflect successful save
        selectedPlanState.originalSeats = selectedPlanState.seats;
        selectedPlanState.originalCouponCode = selectedPlanState.couponCode;
        selectedPlanState.originalBillingEmail = selectedPlanState.billingEmail;
      } catch (error) {
        // Error handling is done in the store
      } finally {
        selectedPlanState.isUpdating = false;
      }
    };
    const updatePaymentInformation = () => {
      window.location.href = props.subscription?.selfServicePaymentUrl;
    };
    const contact = () => {
      openChat();
    };
    const cancelSubscription = () => {
      maxioCompanySubscriptionStore.notifyCancelIntent();
      selectedPlanState.showCancelSubscriptionModal = true;
    };
    return (_ctx, _cache) => {
      const _component_v_sheet = _resolveComponent("v-sheet");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_card_text = _resolveComponent("v-card-text");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_v_container, null, {
        default: _withCtx(() => [!__props.subscription?.isCustomPlan ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
            'flex flex-row justify-between bg-gray-100 shadow-md tw': !__props.isSmallScreen
          })
        }, [_createVNode(_component_v_container, null, {
          default: _withCtx(() => [_createVNode(_component_v_row, {
            "no-gutters": ""
          }, {
            default: _withCtx(() => [_createVNode(_component_v_col, {
              cols: "12"
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass(["flex flex-row justify-between", {
                  'centered-block': __props.isSmallScreen
                }])
              }, [_createElementVNode("div", {
                class: _normalizeClass(["flex flex-col w-2/3", {
                  'hide-block': __props.isSmallScreen
                }])
              }, [_createElementVNode("div", {
                class: _normalizeClass({
                  'text-center': __props.isSmallScreen
                })
              }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("strong", null, _toDisplayString(__props.subscription.plan?.label), 1)]), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(__props.subscription.plan?.description), 1)])) : _createCommentVNode("", true), __props.subscription.plan?.link ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: __props.subscription.plan?.link,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
                class: "text-primary pr-2"
              }, "Learn More", -1), _createElementVNode("span", {
                class: "text-primary fa fa-arrow-right"
              }, null, -1)]))], 8, _hoisted_5)) : _createCommentVNode("", true)])], 2), !_unref(maxioCompanySubscriptionStore).isActiveSubscription ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_v_row, {
                "no-gutters": ""
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  order: "first"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_sheet, {
                    class: "px-2 mx-2 pt-2"
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("span", {
                      class: "text-black"
                    }, "Seats (Users):", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(LlTextField, {
                    modelValue: selectedPlanState.seats,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedPlanState.seats = $event),
                    label: "",
                    min: selectedPlanState.minSeats,
                    type: "number",
                    "hide-details": false,
                    rules: [v => {
                      const isValid = Number(v) >= selectedPlanState.minSeats;
                      selectedPlanState.seatsValid = isValid;
                      return isValid || `Seats cannot be less than ${selectedPlanState.minSeats}`;
                    }]
                  }, null, 8, ["modelValue", "min", "rules"])])]),
                  _: 1
                }), _createVNode(_component_v_col, {
                  order: "last"
                })]),
                _: 1
              }), _createVNode(_component_v_row, {
                "no-gutters": ""
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  order: "middle"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_sheet, {
                    class: "px-2 mx-2 pt-2"
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("span", {
                      class: "text-black"
                    }, "Coupon Code ", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(LlTextField, {
                    modelValue: selectedPlanState.couponCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedPlanState.couponCode = $event),
                    label: "",
                    "hide-details": false,
                    color: "primary"
                  }, null, 8, ["modelValue"])])]),
                  _: 1
                }), _createVNode(_component_v_col, {
                  order: "last"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_sheet, {
                    class: "px-2 mx-2 pt-1"
                  }, {
                    default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                      class: "font-semibold disabled:text-gray-400",
                      variant: "text",
                      color: "primary",
                      size: "small",
                      disabled: !selectedPlanState.couponCode,
                      onClick: validateCode
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" Validate ", -1)]))]),
                      _: 1
                    }, 8, ["disabled"])]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_v_row, {
                "no-gutters": ""
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  order: "first"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_sheet, {
                    class: "px-2 mx-2 pt-2"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("span", {
                      class: "text-black"
                    }, " Billing Email", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(LlTextField, {
                    modelValue: selectedPlanState.billingEmail,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => selectedPlanState.billingEmail = $event),
                    label: "",
                    color: "primary",
                    type: "email",
                    "hide-details": false,
                    rules: [v => {
                      const isValid = !v || _unref(isValidSingleEmail)(v);
                      selectedPlanState.emailValid = isValid;
                      return isValid || 'Please enter a valid email address.';
                    }]
                  }, null, 8, ["modelValue", "rules"])])]),
                  _: 1
                }), _createVNode(_component_v_col, {
                  order: "last"
                })]),
                _: 1
              })])) : _createCommentVNode("", true)], 2), !_unref(features)?.customPricing ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "pa-2"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(__props.subscription.plan?.label), 1), _createElementVNode("div", _hoisted_13, [_createTextVNode(" $ " + _toDisplayString(_unref(formattedDisplayAmount)) + " ", 1), _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(billingPeriodText)), 1)]), _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(priceBreakdown)), 1), _createElementVNode("div", _hoisted_16, [_createVNode(LlIcon, {
                  icon: "mdi-check-circle",
                  class: "mr-2"
                }), _cache[9] || (_cache[9] = _createElementVNode("span", null, "Selected", -1))])]), _createVNode(_component_v_card_actions, {
                  class: "align-center justify-center"
                }, {
                  default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                    color: "primary",
                    onClick: pickDifferentPlan
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Pick a different plan ", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                })])]),
                _: 1
              })) : _createCommentVNode("", true)], 2), _createVNode(_component_v_col, {
                cols: "12",
                class: _normalizeClass({
                  'hide-block': !(__props.isSmallScreen && selectedPlanState.disableStartSubscription)
                })
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createVNode(LlSecondaryButton, {
                  color: "primary",
                  class: "w-52",
                  onClick: updatePaymentInformation
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Add Payment Method ", -1)]))]),
                  _: 1
                })])]),
                _: 1
              }, 8, ["class"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })], 2)) : _createCommentVNode("", true)]),
        _: 1
      }), __props.isSmallScreen ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0
      }, {
        default: _withCtx(() => [!_unref(maxioCompanySubscriptionStore).isActiveSubscription ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 0,
          class: "d-flex align-center justify-between flex-row mb-6 bg-surface-variant"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_sheet, {
            class: "ma-2"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              color: "primary",
              onClick: updateSubscription,
              disabled: selectedPlanState.isUpdating || !hasChanges.value || !isFormValid.value,
              loading: selectedPlanState.isUpdating
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(selectedPlanState.isUpdating ? 'Updating...' : 'Update Subscription'), 1)]),
              _: 1
            }, 8, ["disabled", "loading"])]),
            _: 1
          }), _createVNode(_component_v_sheet, {
            class: "ma-2"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              onClick: contact
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("Contact Us", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("div", null, [_createVNode(_component_v_sheet, {
          class: _normalizeClass([{
            'centered-block': __props.isSmallScreen
          }, "d-flex align-center justify-between flex-row mb-6 bg-surface-variant"])
        }, {
          default: _withCtx(() => [_createVNode(_component_v_sheet, {
            class: _normalizeClass([{
              'hide-block': __props.isSmallScreen
            }, "ma-2 pa-2 mb-auto"])
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createElementVNode("h3", {
              class: "text-black"
            }, "Start Subscription", -1)]))]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_v_sheet, {
            class: "ma-2"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              color: "primary",
              onClick: startSubscription,
              disabled: selectedPlanState.disableStartSubscription
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("Start Leanlaw Subscription ", -1)]))]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["class"])])]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_v_container, {
        class: _normalizeClass({
          'hide-block': __props.isSmallScreen
        })
      }, {
        default: _withCtx(() => [_createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createVNode(_component_v_col, {
            cols: "12"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_sheet, {
              class: "pa-4 ma-2 bg-gray-50 rounded-lg"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [__props.subscription?.isCustomPlan ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Your firm is on a custom plan. Please contact us to make changes to your subscription. ")) : (_openBlock(), _createElementBlock("div", _hoisted_21, " Call us if you have any questions related to your subscription ")), _createVNode(LlSecondaryButton, {
                onClick: contact
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("Contact Us", -1)]))]),
                _: 1
              })]), !_unref(maxioCompanySubscriptionStore).isActiveSubscription ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(LlSecondaryButton, {
                color: "primary",
                variant: "flat",
                onClick: updateSubscription,
                disabled: selectedPlanState.isUpdating || !hasChanges.value || !isFormValid.value,
                loading: selectedPlanState.isUpdating
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(selectedPlanState.isUpdating ? 'Updating...' : 'Update LeanLaw Subscription'), 1)]),
                _: 1
              }, 8, ["disabled", "loading"])])) : _createCommentVNode("", true)])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), (_unref(maxioCompanySubscriptionStore).isAwaitingSubscription || _unref(maxioCompanySubscriptionStore).isActiveSubscription && !props.subscription?.scheduledCancellationDate) && props.subscription?.allowSelfServiceCancellation ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(_component_v_col, {
            cols: "12"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card_text, {
              class: ""
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(LlSecondaryButton, {
                onClick: cancelSubscription
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Cancel Subscription ", -1)]))]),
                _: 1
              })])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["class"]), selectedPlanState.showCancelSubscriptionModal ? (_openBlock(), _createBlock(CancelSubscriptionModal, {
        key: 1,
        alerts: props.alerts,
        subscription: props.subscription,
        onClose: _cache[3] || (_cache[3] = $event => selectedPlanState.showCancelSubscriptionModal = false)
      }, null, 8, ["alerts", "subscription"])) : _createCommentVNode("", true)], 64);
    };
  }
};